<template>
  <div
    v-if="vista"
    id="FelicitacionNavidad"
    class="modal"
  >
    <div class="modal-content col col-12 col-sm-10 col-md-8 col-lg-6">
      <span
        class="close"
        @click="vista=false"
      >
        &times;
      </span>
      <base-img
        :src="require('@/assets/modal_felicitacion_navidad.jpeg')"
        max-height="100%"
        width="100%"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SectionModal',

    data: () => ({
      vista: false,
    }),
  }
</script>

<style scoped>
.modal {
  /* display: none; */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  /* background-color: #fefefe;
  border: 1px solid #888;
  width: 80%; */
  margin: auto;
  padding: 20px;
  background-color: transparent;
  border: none;
  /* max-width: 60vw;
  max-height: 60vh;
  width: 50%; */
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
